import { CurriculumRow } from '../CurriculumRow';

interface CurriculumBodyProps {
  rows: any[];
}

export const CurriculumBody = ({ rows }: CurriculumBodyProps) => {
  return (
    <tbody>
      {rows.map((row: any, index: number) => {
        return <CurriculumRow key={`${row.id}-${index}`} Tag="td" row={row} />;
      })}
    </tbody>
  );
};
